// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 20) return "static/js/f60dafdc7e378d550980.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"b2a7970ba10d5554351e","121":"8bcdf3f2860649c2cc6d","122":"400409bfd715b53260dc"}[chunkId] + ".chunk.js";
};